<template>
  <div class='wareWrap' :style="`height:${height}px`">
    <div class='wareList' :style="`height:${height}px`">
      <div :class="['wareList-item',{wareActive:wareId==item.wareId}]" v-for='item in wareList' :key='item.wareId' @click='changeWare(item.wareId)'>
        <i class="el-icon-s-home"></i>
        <span class='wareName'>{{item.wareName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    wareList:Array,
    wareId:Number,
    height:Number
  },
  methods:{
    changeWare(wareId){
      this.$emit('getWareId',wareId)
    }
  }
}
</script>

<style>
  .wareWrap{
    width: 210px;
    border-right: 5px solid #f0f4f7;
    box-sizing: border-box
  }
  .wareList{
    width: 210px;
    overflow: auto;
    padding-left: 20px;
    padding-top: 10px;
    box-sizing: border-box;
  }
  .wareList-item{
    height: 45px;
    width: 160px;
    margin-bottom: 10px;
    border-radius: 5px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: gray;
    border: 1px solid #c5c5c5;
    cursor: pointer;
  }
  .el-icon-s-home{
    font-size: 20px;
    display: inline-block;
    margin-right: 10px;
  }
  .wareName{
    display: inline-block;
    width: 80px;
    text-align-last:justify;
  }
  .wareActive{
    border: 1px solid #20bd9e;
    background: #dcf7ee
  }
  .wareActive .el-icon-s-home{
    color: #20bd9e
  }
</style>